import React from 'react'
import { Route, Routes } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { useOrgPerm } from '@/hooks/useOrgPerm'
import { WrapperProps } from '@/shared/routes'
import Layout from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'

import BillingMainPage from './BillingMainPage/BillingMainPage'
import { BillingProvider } from './Providers/BillingProviders'
import { billingRoutes } from './routes'

/**
 * Org Billing routes wrapper
 * TODO: Integrate with Makyo SDK
 */
export default function OrgBillingRoutes({ title }: WrapperProps) {
  const canViewActivities = useOrgPerm(OrgPermission.BillingViewActivities)
  const canManageSubscriptions = useOrgPerm(OrgPermission.BillingManageSubscriptions)
  const canManagePm = useOrgPerm(OrgPermission.BillingManagePaymentMethods)
  const canManageAddresses = useOrgPerm(OrgPermission.BillingManageAddresses)
  const canEither = canViewActivities || canManageSubscriptions || canManagePm || canManageAddresses

  if (!canEither) {
    return (
      <Layout title={title}>
        <PageUnauthorized />
      </Layout>
    )
  }

  return (
    <BillingProvider>
      <BillingMainPage>
        <Routes>
          {billingRoutes.map(({ component: Comp, ...rest }) => {
            return <Route key={`billing-${rest.path || 'index'}`} {...rest} element={<Comp />} />
          })}
        </Routes>
      </BillingMainPage>
    </BillingProvider>
  )
}
